/** Parse YYYY-MM-DD as a local calendar day (avoids UTC midnight shifting the day). */
export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dateStr));
  if (match) {
    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3])
    );
  }
  const parsed = new Date(dateStr);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/** Parse "9:05 AM" / "11:59 PM" into { hours, minutes }. Defaults to end of day. */
export const parseClockTime = (timeStr, fallback = { hours: 23, minutes: 59 }) => {
  if (!timeStr || typeof timeStr !== "string") return fallback;
  const match = timeStr.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
  if (!match) return fallback;

  let hours = Number(match[1]);
  const minutes = Number(match[2]);
  const ampm = match[3]?.toUpperCase();

  if (ampm === "PM" && hours < 12) hours += 12;
  if (ampm === "AM" && hours === 12) hours = 0;
  if (!ampm && hours > 23) return fallback;

  return { hours, minutes };
};

/**
 * Schedule end instant in local time.
 * Date-only strings used to become UTC midnight → false "Expired" the same day.
 * Prefer endDate + endTime; if time is missing, use end of that local day.
 */
export const getScheduleEndDate = (schedule) => {
  if (!schedule?.endDate) return null;
  const day = parseLocalDate(schedule.endDate);
  if (!day) return null;

  const { hours, minutes } = parseClockTime(schedule.endTime);
  day.setHours(hours, minutes, 59, 999);
  return day;
};

export const isScheduleExpired = (schedule, now = new Date()) => {
  const end = getScheduleEndDate(schedule);
  return Boolean(end && end < now);
};
